import React, {Component} from "react";
import {connect} from "react-redux";
import {AppState} from "../store/reducers";
import {deleteCompanyContactForm} from "../store/actions/companyContactForm";
import {Alert, Button, Spinner} from "reactstrap";


type CompanyContactDeleteType = {
    deleteCompanyContactForm: (sectionId: number, id: number) => void
    cancelHandler?: () => void
    id: number
    sectionId: number
    changeLoading: boolean
    changeError: string
}

class CompanyContactDeleteContainer extends Component<CompanyContactDeleteType> {

    deleteHandler = () => {
        const {id, deleteCompanyContactForm, sectionId} = this.props;
        deleteCompanyContactForm(sectionId, id)
    };

    render() {
        const {changeLoading, changeError, cancelHandler} = this.props;

        return (
            <>
                {changeError &&
                (<Alert className={'mt-3'} color={'danger'}>
                    {changeError}
                </Alert>)}
                <div className={'text-right'}>
                    {cancelHandler &&
                    <Button onClick={cancelHandler} color={'primary'} className={'mr-3'}>Не удалять</Button>}
                    <Button onClick={this.deleteHandler} color={'danger'} disabled={changeLoading}>
                        {changeLoading &&
                        (<Spinner
                            size="sm"
                        />)}
                        Да, удалить
                    </Button>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: AppState) => {
    const {changeLoading, changeError} = state.companyContactForm;

    return {
        changeLoading,
        changeError
    }
};

const mapDispatchToProps = {
    deleteCompanyContactForm
};


export default connect(mapStateToProps, mapDispatchToProps)(CompanyContactDeleteContainer);
